import {LitElement} from 'lit';
import tippy, {Instance as TippyInstance, Props} from 'tippy.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Constructor<T = {}> = new (...args: any[]) => T;

export declare interface IToolTippy {
  tooltip: TippyInstance;
  costTooltips: TippyInstance[];
  effectTooltips: TippyInstance[];
  _updateTooltip(): void;
}

export const ToolTippy = <T extends Constructor<LitElement>>(
  superClass: T,
  tippyOptions?: Partial<Props>
) => {
  class ToolTippyClass extends superClass {
    tooltip: TippyInstance = tippy(this);
    costTooltips: TippyInstance[] = [];
    effectTooltips: TippyInstance[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args: any[]) {
      super(...args);
      this.tooltip.setProps({
        allowHTML: true,
        interactive: true,
        interactiveBorder: 10,
        maxWidth: 'none',
        delay: [350, 0],
        duration: [null, 0],
        ...tippyOptions,
      });
      setInterval(this._updateTooltip.bind(this), 100);
    }
    tooltipContent: () => string = () => '';
    _updateTooltip() {
      this.tooltip.setContent(this.tooltipContent());
    }
  }
  return ToolTippyClass as Constructor<IToolTippy> & T;
};
